import { render, staticRenderFns } from "./goodCommon.vue?vue&type=template&id=ef019468&scoped=true&"
import script from "./goodCommon.vue?vue&type=script&lang=js&"
export * from "./goodCommon.vue?vue&type=script&lang=js&"
import style0 from "./goodCommon.vue?vue&type=style&index=0&id=ef019468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef019468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef019468')) {
      api.createRecord('ef019468', component.options)
    } else {
      api.reload('ef019468', component.options)
    }
    module.hot.accept("./goodCommon.vue?vue&type=template&id=ef019468&scoped=true&", function () {
      api.rerender('ef019468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/goodCommon.vue"
export default component.exports